window.theme.component('accordion', el => {
    /**
     * Close an item.
     *
     * @param {HTMLElement} item
     */
    function closeItem(item) {
        if (!item.classList.contains('is-active')) return;

        item.classList.remove('is-active');
        item.querySelector('.js-item-content').removeAttribute('style');

        const toggle = item.querySelector('.js-item-toggle');

        if (toggle) {
            toggle.setAttribute('aria-expanded', 'false');
        }
    }

    /**
     * Open an item.
     *
     * @param {HTMLElement} item
     */
    function openItem(item) {
        if (item.classList.contains('is-active')) return;

        item.classList.add('is-active');

        updateActiveItemHeight();

        const toggle = item.querySelector('.js-item-toggle');

        if (toggle) {
            toggle.setAttribute('aria-expanded', 'true');
        }
    }

    /**
     * Update the active item's height.
     */
    function updateActiveItemHeight() {
        const activeItem = el.querySelector('.js-item.is-active');
        if (!activeItem) return;

        const contentWrapper = activeItem.querySelector('.js-item-content-wrapper');
        
        if(!contentWrapper) return; 
        
        const contentHeight = contentWrapper.scrollHeight;

        if (contentHeight > 0) {
            activeItem.querySelector('.js-item-content').style.height = `${contentHeight}px`;
        }
    }

    // Detect clicks on the accordion.
    el.addEventListener('click', ({target}) => {
        const toggle = target.closest('.js-item-toggle');
        if (!toggle) return;

        // Get the item this toggle belongs to.
        const item = toggle.parentNode.parentNode;

        // Close the item if it's already active.
        if (item.classList.contains('is-active')) {
            closeItem(item);
        } else {
            // Close the currently active item.
            const activeItem = el.querySelector('.js-item.is-active');
            if (activeItem) closeItem(activeItem);

            // Open the item.
            openItem(item);
        }
    });

    // Update the active item's height when the window is resized.
    let updateTimeout = false;

    window.addEventListener('resize', () => {
        clearTimeout(updateTimeout);
        updateTimeout = setTimeout(() => updateActiveItemHeight(), 150);
    });

    /**
     * Handle keyboard navigation
     */
    const toggleButtons = el.querySelectorAll('.js-item-toggle');
    toggleButtons.forEach((toggle, index) => {
        toggle.addEventListener('keydown', event => {

            if (!event.key) return;

            let targetIndex;

            if (event.key === 'ArrowUp') {
                targetIndex = (index > 0) ? index - 1 : toggleButtons.length - 1;
            } else if (event.key === 'ArrowDown') {
                targetIndex = (index < toggleButtons.length - 1) ? index + 1 : 0;
            }

            if(targetIndex === undefined) return;

            toggleButtons[targetIndex].focus();
        });
    });

    /**
     * Initial State
     */
    updateActiveItemHeight();
});
